export const jobTimelineAvailabilityInitialState = {
  availableTimeSlots: [] as string[],
  selectedTimeSlot: undefined as string | undefined,
  movingDate: null as Date | null,
} as const;
